export default __webpack_public_path__ + "static/media/FoodWeb_05.27ca0a5d.png";